<template>
  <div class="p-4 max-w-xl mx-auto" v-if="!isLoading">
    <div
      @click="$router.back()"
      class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
    >
      <BackSvg />
    </div>

    <div class="pb-6 flex flex-col justify-center items-center">
      <h2 class="text-lg text-zinc-700 text-center font-semibold">
        Data Privacy Policy
      </h2>
    </div>
    <div>
      <!-- 1. Introduction & Nature of Teleconsultation -->
      <section class="space-y-2">
        <h3 class="font-semibold text-gray-900">
          1. Introduction & Nature of Teleconsultation
        </h3>
        <p>I understand that:</p>
        <ul class="list-disc list-inside space-y-1">
          <li>
            Teleconsultation involves the use of electronic devices (e.g.,
            computer, smartphone) to communicate with a licensed physician for
            purposes of diagnosis, treatment, follow-up, and/or education.
          </li>
          <li>
            The teleconsultation may involve live two-way audio and video,
            sharing of medical images, medical records, or other relevant health
            data.
          </li>
          <li>
            This method of consultation may not be appropriate for all medical
            conditions, especially those requiring a physical examination.
          </li>
        </ul>
      </section>
      <br />
      <!-- 2. Confidentiality and Privacy -->
      <section class="space-y-2">
        <h3 class="font-semibold text-gray-900">
          2. Confidentiality and Privacy
        </h3>
        <p>I acknowledge:</p>
        <ul class="list-disc list-inside space-y-1">
          <li>
            My personal health information will be treated confidentially.
          </li>
          <li>
            The teleconsultation system will use security measures
            (network/software) to protect my identity, data integrity, and
            privacy.
          </li>
          <li>
            The processing of my personal and health data (sensitive personal
            information) will comply with the Data Privacy Act of 2012 (RA
            10173).
          </li>
          <li>
            I have the right to know how my data will be used, stored, shared,
            and for how long; and whom to contact about my data privacy concerns
            (e.g., the Data Protection Officer).
          </li>
        </ul>
      </section>
      <br />
      <!-- 3. Risks & Limitations -->
      <section class="space-y-2">
        <h3 class="font-semibold text-gray-900">3. Risks & Limitations</h3>
        <p>I understand:</p>
        <ul class="list-disc list-inside space-y-1">
          <li>
            There is a risk of technology failure (poor internet connection,
            software issues) that could interrupt or degrade the quality of the
            consultation.
          </li>
          <li>
            There is a risk, though minimized, of a breach in confidentiality
            despite security measures.
          </li>
          <li>
            Teleconsultation might not be sufficient for certain medical
            problems; I may need to have an in-person visit if required.
          </li>
        </ul>
      </section>
      <br />
      <!-- 4. Right to Refuse or Discontinue -->
      <section class="space-y-2">
        <h3 class="font-semibold text-gray-900">
          4. Right to Refuse or Discontinue
        </h3>
        <ul class="list-disc list-inside space-y-1">
          <li>
            I have the right to refuse or withdraw my consent at any time during
            or before the teleconsultation.
          </li>
          <li>
            Refusing or stopping the teleconsultation will not affect my right
            to future in-person consultations or medical care.
          </li>
        </ul>
      </section>
      <br />
      <!-- 5. Identification & Verification -->
      <section class="space-y-2">
        <h3 class="font-semibold text-gray-900">
          5. Identification & Verification
        </h3>
        <ul class="list-disc list-inside space-y-1">
          <li>
            I confirm that I am within the territorial jurisdiction of the
            Philippines, and that the physician I will consult with is licensed
            to practice in the Philippines.
          </li>
          <li>
            Both the patient and the physician will verify their identities at
            the start of the teleconsultation.
          </li>
        </ul>
      </section>
      <br />
      <!-- 6. Records and Documentation -->
      <section class="space-y-2">
        <h3 class="font-semibold text-gray-900">
          6. Records and Documentation
        </h3>
        <ul class="list-disc list-inside space-y-1">
          <li>
            I understand that a clinical summary, prescription (if applicable),
            or referral may be sent via electronic means (e.g., email) in a
            format that is acceptable under Philippine law (e.g., Electronic
            Commerce Act).
          </li>
          <li>
            I have the right to request a copy of the electronic clinical
            summary or medical records generated during the teleconsultation.
          </li>
        </ul>
      </section>
    </div>
  </div>

  <div v-else class="flex items-center justify-center h-48">
    <svg
      class="w-10 h-10 animate-spin text-orange-600"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      ></path>
    </svg>
  </div>
</template>

<script>
import { ref } from "vue";
import BackSvg from "@/components/svgs/BackSvg.vue";

export default {
  name: "UpdateProfile",
  components: { BackSvg },
  setup() {
    const isLoading = ref(false);
    const isAlert = ref(false);
    const loading = ref(false);

    return {
      isLoading,
      isAlert,
      loading,
    };
  },
};
</script>
